module.exports = __webpack_public_path__ + "img/nerdof_live.5eef186d.png";